import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    Menu,
    Paper,
    Tab,
    Tabs,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { get, includes, toLower } from "lodash";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import FormTitle from "../../../common/js/components/FormTitle";
import Gallery from "../../../common/js/components/Gallery";
import Snackbar from "../../../common/js/components/KMSnackbar";
import KMSwitch from "../../../common/js/components/KMSwitch";
import LeaseAndSaleDropdownOptions from "../../../common/js/components/LeaseAndSaleDropdownOptions";
import { Add, Comments, LeftChevron } from "../../../common/js/icons";
import CompsTable from "../comp/CompsTableContainer";
import DocumentDrop from "../documents/DocumentDropContainer";
import ListingDataPreview from "../listing/ListingDataPreview";
import RequestModalContainer from "../listing/RequestModalContainer";
import HealthcareForm from "../property/HealthcareForm";
import ResearchTab from "../research/ResearchTab";
import { us_states_options } from "../utils/constants";
import { buildAddress, filterActiveListings, filterByQuery, toDollarAmount, toSqft } from "../utils/operations";
import AssetServicesDeleteModalContainer from "./AssetServicesDeleteModalContainer";
import AssetServicesSnapshotModalContainer from "./AssetServicesSnapshotModalContainer";
import BuildingForm from "./BuildingForm";
import { compColumnsTofilter, getSpecialtyTypeDisplayName, listingColumnsTofilter } from "./constants";
import HospitalityForm from "./HospitalityForm";
import IndustrialForm from "./IndustrialForm";
import LandForm from "./LandForm";
import MultifamilyForm from "./MultifamilyForm";
import OfficeForm from "./OfficeForm";
import OtherForm from "./OtherForm";
import ParkingInfoForm from "./ParkingInfoForm";
import AssetServicesTab from "./PropertyAssetServicesTab";
import RetailForm from "./RetailForm";
import SaveAndSyncContainer from "./SaveAndSyncContainer";

const PageToolbar = styled("div")(({ theme }) => ({
    margin: "20px -4px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    width: "100%",
}));

const PaperPadding = styled(Paper)({
    padding: "5px 20px 20px",
    marginBottom: "24px",
});

const PaperHeading = styled("h3")({
    fontSize: "18px",
    margin: "14px 0",
});

const Hr = styled("hr")({
    margin: "0 -20px 20px -20px",
});

const DefTerm = styled("span")({
    fontSize: "13px",
    textTransform: "uppercase",
    color: "#9E9E9E",
    fontWeight: 600,
    lineHeight: "26px",
    whiteSpace: "nowrap",
});

const DefData = styled("span")({
    fontSize: "14px",
    color: "#000",
});

const TabOne = styled(Tab)({
    marginRight: "20px",
});

const AlternateContent = styled("div")({
    margin: "auto",
    textAlign: "center",
    marginTop: "3em",
    marginBottom: "3em",
    color: "rgba(0, 0, 0, 0.30)",
    fontSize: "20px",
});

const MoveIt = styled(Button)({
    marginRight: "20px",
    padding: 0,
    "&:hover": {
        background: "transparent",
    },
});

const LightButton = styled(Button)({
    fontWeight: "400",
});

const LightButtonIcon = styled("span")({
    paddingRight: "3px",
    paddingTop: "6px",
    marginRight: "3px",
});

const AssetServicesButtonsContainer = styled(Grid)({
    display: "flex",
    alignItems: "center",
});

const FlexRow = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    gap: "2px",
    margin: "-4px",
});

const GeneralInfoItem = styled("div")({
    flexGrow: 1,
    flexBasis: 0,
    maxWidth: "100%",
    padding: "4px",
    boxSizing: "border-box",
});

const PropertyInformation = styled("div")({
    flexGrow: 0,
    flexBasis: "50%",
    maxWidth: "50%",
    padding: "12px",
    boxSizing: "border-box",
});

const PropertyInfoWrapper = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    margin: "-4px",
    boxSizing: "border-box",
});

const PropertyInfoFlex = styled("div")({
    flexGrow: 0,
    maxWidth: "100%",
    flexBasis: "100%",
    padding: "4px",
    boxSizing: "border-box",
});

const PropertyInfoFlexHalf = styled("div")({
    flexGrow: 0,
    maxWidth: "50%",
    flexBasis: "50%",
    padding: "4px",
    boxSizing: "border-box",
});

const PropertyInfoFlexThird = styled("div")({
    flexGrow: 0,
    maxWidth: "33.33333%",
    flexBasis: "33.33333%",
    padding: "4px",
    boxSizing: "border-box",
});

const PropertyDetail = (props) => {
    const {
        addListingGivenProperty,
        closeDeal,
        compHistory,
        elementsSaving,
        errors,
        getFlyer,
        handleInput,
        history,
        images,
        isLoading,
        listings,
        navigateToRequestPropertyUpdate,
        navigateToRequestUpdate,
        property,
        propertyKey,
        propertyManagement,
        propertyType,
        role,
        switchTab,
        tab,
        toggleRequestModal,
    } = props;

    const [closeDealDialogOpen, setCloseDealDialogOpen] = useState(false);
    const [inactiveListingsOnly, setInactiveListingsOnly] = useState(false);
    const [filterQuery] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState(false);
    const [snackbarVariant, setSnackbarVariant] = useState("");
    const [listingToClose, setListingToClose] = useState(null);
    const [addListingOpen, setAddListingOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(undefined);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleClickOpen = (listing) => {
        setCloseDealDialogOpen(true);
        setListingToClose(listing);
    };

    const handleClose = async () => {
        const result = await closeDeal(listingToClose);
        if (result) {
            if (result.dealKey) {
                history.push(`/deal/${result.dealKey}`);
            }
        }
        setCloseDealDialogOpen(false);
        setListingToClose(null);
    };

    const handleAddListingMenuOpen = (anchorEl) => {
        setAddListingOpen(true);
        setAnchorEl(anchorEl);
    };

    const handleAddListingMenuClose = () => {
        setAddListingOpen(false);
    };

    const handlePropertyRequestUpdate = () => {
        const propertyKey = get(property, "propertyKey");
        navigateToRequestPropertyUpdate(propertyKey, `/propdetail/${propertyKey}`);
        history.push(`/property/${propertyKey}`);
    };

    const toggleInactiveListingsOnly = () => {
        setInactiveListingsOnly(!inactiveListingsOnly);
    };

    const handleEditResearchSnapshot = (result) => {
        if (result === true) {
            setSnackbarMessage("Success: Your edits have been applied");
            setSnackbarVariant("success");
            setSnackbarOpen(true);
        } else if (result === false) {
            setSnackbarMessage("Failed: Your edit was not processed.");
            setSnackbarVariant("error");
            setSnackbarOpen(true);
        }
    };

    const navigateToEditProperty = () => {
        const propertyKey = get(property, "propertyKey");
        history.push(`/property/${propertyKey}`);
    };

    const filteredListings =
        listings && listings instanceof Array
            ? listings
                  .filter((k) => filterActiveListings(k, inactiveListingsOnly))
                  .filter((x) => filterByQuery(x, listingColumnsTofilter, filterQuery))
            : listings;

    const filteredComps =
        filterQuery && compHistory
            ? compHistory.filter((x) => filterByQuery(x, compColumnsTofilter, filterQuery))
            : compHistory;

    return (
        <React.Fragment>
            <Snackbar
                open={snackbarOpen}
                message={snackbarMessage}
                variant={snackbarVariant}
                vertical="top"
                horizontal="center"
                autoHideDuration={3000}
                onClose={() => {
                    setSnackbarOpen(false);
                }}
            />
            <PageToolbar>
                <div style={{ minWidth: 0, padding: "4px" }}>
                    <Link to="/properties">
                        <LeftChevron />
                    </Link>
                </div>
                <div style={{ flex: 1, padding: "4px" }}>
                    <h2 className="page-title">{get(property, "propertyAttributes.propertyName", "")}</h2>
                    <p className="page-subtitle">{buildAddress(get(property, "primaryAddress", {}))}</p>
                </div>
                <div style={{ flex: 1, textAlign: "right", padding: "4px" }}>
                    <h2 className="page-title text-right">
                        {`${toDollarAmount(get(property, "propertyAttributes.avgAnnualPsfRate", 0))} ${
                            get(property, "propertyAttributes.avgAnnualPsfRate", null) ? "-" : ""
                        } ${toDollarAmount(get(property, "propertyAttributes.blendedRate", 0))} USD/SF/YR`}
                    </h2>
                    <p className="page-subtitle text-right">{`${toSqft(
                        get(property, "propertyAttributes.totalBldgSf", 0)
                    )} | ${get(property, "propertyType", 0)}`}</p>
                </div>
            </PageToolbar>
            <div style={{ display: "flex", width: "100%", gap: "16px" }}>
                <div style={{ flex: "0 0 40%", maxWidth: "40%" }}>
                    <Gallery
                        propertyKey={propertyKey}
                        images={Object.keys(images).map((key) => {
                            return images[key].url;
                        })}
                    ></Gallery>
                </div>
                <div style={{ flex: "1 1 60%", maxWidth: "60%" }}>
                    <PaperPadding>
                        <PaperHeading>General Information</PaperHeading>
                        <Hr />
                        {isLoading === false && (
                            <React.Fragment>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>Property ID</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{property.propertyKey}</DefData>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>Leed Certification</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>
                                            {get(property, "propertyAttributes.leedCertFlg", false) === true
                                                ? property.propertyAttributes.leedCertLevel
                                                : "None"}
                                        </DefData>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>Property SF</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{toSqft(get(property, "propertyAttributes.totalBldgSf", {}))}</DefData>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>Property Type</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{property.propertyType}</DefData>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>KM Managed SF</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{toSqft(get(propertyManagement, "grossSqFt", {}))}</DefData>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>Property Use</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>
                                            {getSpecialtyTypeDisplayName(
                                                get(property, "propertyType"),
                                                get(property, "propertyAttributes.specialtyType", "-")
                                            )}
                                        </DefData>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>Unit Count</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{get(property, "propertyAttributes.totalUnits", "-")}</DefData>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>Condo Units</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>
                                            {get(property, "propertyAttributes.condoFlg", false) === true
                                                ? "Yes"
                                                : "No"}
                                        </DefData>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>Room Count</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>{get(property, "propertyAttributes.roomCount", "-")}</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>Market Area</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>{get(property, "propertyAttributes.marketArea", "-")}</DefTerm>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm># of Floors</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>{get(property, "propertyAttributes.numFloors", "-")}</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>Submarket Area</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{get(property, "propertyAttributes.submarketArea", "-")}</DefData>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>PM Client Property ID</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{get(propertyManagement, "accountingSoftwareId", "")}</DefData>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm>Micro Market</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{get(property, "propertyAttributes.micromarketArea", "-")}</DefData>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>Property Manager</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefData>{get(property, "propertyManagerName", "")}</DefData>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm></DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm></DefTerm>
                                    </GeneralInfoItem>
                                </FlexRow>
                                <FlexRow>
                                    <GeneralInfoItem>
                                        <DefTerm>Appraiser</DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm></DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm></DefTerm>
                                    </GeneralInfoItem>
                                    <GeneralInfoItem>
                                        <DefTerm></DefTerm>
                                    </GeneralInfoItem>
                                </FlexRow>
                            </React.Fragment>
                        )}
                    </PaperPadding>
                </div>
            </div>
            <PaperPadding>
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        width: "100%",
                        boxSizing: "border-box",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Grid item>
                        <Tabs value={tab} onChange={switchTab}>
                            <TabOne value="property" label="Property" />
                            <Tab value="property_listings" label="Listings" />
                            <Tab value="comp_history_for_property" label="Comp History" />
                            {includes(
                                ["propertyManagement", "transition", "accounting", "dataEntry", "dataAdmin"],
                                role
                            ) && <Tab value="property_management" label="Asset Services" />}
                            {includes(["research", "researchAdmin", "dataAdmin", "dataEntry"], role) && (
                                <Tab value="research_tab" label="Research" />
                            )}
                        </Tabs>
                    </Grid>
                    {tab === "property_management" &&
                        propertyManagement &&
                        includes(["transition", "dataEntry", "dataAdmin"], role) && (
                            <AssetServicesButtonsContainer>
                                <AssetServicesDeleteModalContainer propertyKey={propertyKey} />
                                <AssetServicesSnapshotModalContainer propertyKey={propertyKey} />
                                <SaveAndSyncContainer />
                            </AssetServicesButtonsContainer>
                        )}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", width: "100%", boxSizing: "border-box" }}>
                    <div style={{ flex: "1 0 0", maxWidth: "100%", boxSizing: "border-box", paddingBottom: "4px" }}>
                        <Divider />
                    </div>
                </div>

                {/*** Listings ***/}

                {tab === "property_listings" && (
                    <React.Fragment>
                        <div
                            style={{
                                justifyContent: "space-between",
                                display: "flex",
                                flexWrap: "wrap",
                                boxSizing: "border-box",
                                width: "100%",
                            }}
                        >
                            <div style={{ boxSizing: "border-box" }}>
                                <PaperHeading style={{ marginBottom: "2px" }}>Listings</PaperHeading>
                                <div className="page-subtitle" style={{ marginBottom: "16px" }}>
                                    Showing{" "}
                                    {`${filteredListings.length} ${
                                        filteredListings.length === 1 ? "listing" : "listings"
                                    }`}
                                </div>
                            </div>
                            <div style={{ boxSizing: "border-box" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        boxSizing: "border-box",
                                        margin: "-4px",
                                    }}
                                >
                                    <div style={{ padding: "4px" }}>
                                        <FormControlLabel
                                            label={`Inactive Listings  `}
                                            labelPlacement="start"
                                            style={{ gap: "20px" }}
                                            control={
                                                <KMSwitch
                                                    checked={inactiveListingsOnly}
                                                    onChange={toggleInactiveListingsOnly}
                                                    value={inactiveListingsOnly}
                                                />
                                            }
                                        />
                                        <RequestModalContainer
                                            {...props}
                                            toggleRequestModal={toggleRequestModal}
                                            modalType="listing"
                                        />
                                    </div>
                                    <div style={{ padding: "4px" }}>
                                        <MoveIt
                                            color="primary"
                                            onClick={(e) => handleAddListingMenuOpen(e.currentTarget)}
                                        >
                                            <Add fill="#4b94c1" />
                                            Add Listing
                                        </MoveIt>
                                        <Menu
                                            id="long-menu"
                                            anchorEl={anchorEl}
                                            open={addListingOpen}
                                            onClose={handleAddListingMenuClose}
                                            PaperProps={{
                                                style: {
                                                    width: 200,
                                                },
                                            }}
                                        >
                                            <LeaseAndSaleDropdownOptions
                                                callback={addListingGivenProperty}
                                                property={property}
                                            />
                                        </Menu>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {elementsSaving.property_listings ? (
                            <AlternateContent>
                                <CircularProgress color="primary" />
                            </AlternateContent>
                        ) : filteredListings && filteredListings.length > 0 ? (
                            <React.Fragment>
                                {filteredListings.map((listing, j) => (
                                    <ListingDataPreview
                                        listing={listing}
                                        history={history}
                                        openCloseDealDialog={handleClickOpen}
                                        getFlyer={getFlyer}
                                        navigateToRequestUpdate={navigateToRequestUpdate}
                                        currentPath={`/propdetail/${get(property, "propertyKey", null)}`}
                                        canClose={includes(
                                            ["broker", "portlandBrokerAdmin", "arizonaBrokerAdmin", "evp"],
                                            role
                                        )}
                                    />
                                ))}
                            </React.Fragment>
                        ) : (
                            <AlternateContent>No listings</AlternateContent>
                        )}
                    </React.Fragment>
                )}

                {/*** Comp history ***/}

                {tab === "comp_history_for_property" && (
                    <React.Fragment>
                        <Grid container justifyContent="space-between" spacing={0}>
                            <Grid item>
                                <PaperHeading style={{ marginBottom: "2px" }}>Comps</PaperHeading>
                                <div className="page-subtitle" style={{ marginBottom: "16px" }}>
                                    Showing {`${filteredComps.length} ${filteredComps.length === 1 ? "comp" : "comps"}`}
                                </div>
                            </Grid>
                        </Grid>
                        {elementsSaving.comp_history_for_property ? (
                            <AlternateContent>
                                <CircularProgress color="primary" />
                            </AlternateContent>
                        ) : compHistory && compHistory.length > 0 ? (
                            <CompsTable comps={filteredComps} compTab="comp_history_for_property" />
                        ) : (
                            <AlternateContent>Nothing to Show</AlternateContent>
                        )}
                    </React.Fragment>
                )}

                {/*** Property Management ***/}

                <AssetServicesTab {...props} />

                {/*** Property Information ***/}

                {tab === "property" && (
                    <React.Fragment>
                        <FlexRow>
                            <div style={{ flex: 1, textAlign: "left", padding: "4px" }}>
                                <h3>Property Information</h3>
                            </div>
                            <div style={{ flex: 1, textAlign: "right", padding: "4px" }}>
                                {includes(["dataEntry", "dataAdmin"], role) && (
                                    <Button
                                        onClick={() => navigateToEditProperty(get(property, "propertyKey", null))}
                                        variant="contained"
                                        color="primary"
                                        style={{ marginRight: "10px" }}
                                    >
                                        Edit
                                    </Button>
                                )}
                                {!includes(["dataEntry", "dataAdmin"], role) && (
                                    <LightButton
                                        onClick={handlePropertyRequestUpdate}
                                        color="primary"
                                        style={{ marginRight: "10px" }}
                                    >
                                        <LightButtonIcon>
                                            <Comments fill="#2C99D2" />
                                        </LightButtonIcon>
                                        Request Update
                                    </LightButton>
                                )}
                            </div>
                        </FlexRow>
                        <div style={{ display: "flex", flexWrap: "wrap", margin: "-12px" }}>
                            <PropertyInformation>
                                <PropertyInfoWrapper>
                                    <PropertyInfoFlex>
                                        <BSInput
                                            id="propertyName"
                                            label="Property Name"
                                            placeholder="Enter property name"
                                            value={get(property, "propertyAttributes.propertyName", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlex>
                                </PropertyInfoWrapper>
                                <PropertyInfoWrapper>
                                    <PropertyInfoFlex>
                                        <BSInput
                                            id="address1"
                                            label="Address"
                                            placeholder="Enter address"
                                            value={get(property, "primaryAddress.address1", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlex>
                                </PropertyInfoWrapper>
                                <PropertyInfoWrapper>
                                    <PropertyInfoFlexThird>
                                        <BSInput
                                            id="city"
                                            label="City"
                                            placeholder="Enter city"
                                            value={get(property, "primaryAddress.city.city", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlexThird>
                                    <PropertyInfoFlexThird>
                                        <BSSelect
                                            id="state"
                                            label="State"
                                            placeholder="Select state"
                                            value={get(property, "primaryAddress.city.state.stateCode", "")}
                                            disabled
                                            options={us_states_options}
                                        />
                                    </PropertyInfoFlexThird>
                                    <PropertyInfoFlexThird>
                                        <BSInput
                                            id="zip"
                                            label="Zip"
                                            placeholder="Enter zip code"
                                            value={get(property, "primaryAddress.zipCode.zipCode", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlexThird>
                                </PropertyInfoWrapper>
                                <PropertyInfoWrapper>
                                    <PropertyInfoFlex>
                                        <BSInput
                                            id="propertyCounty"
                                            label="Property County"
                                            placeholder="Select County"
                                            value={get(property, "primaryAddress.county.name", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlex>
                                </PropertyInfoWrapper>
                                <PropertyInfoWrapper>
                                    <PropertyInfoFlexHalf>
                                        <BSInput
                                            id="address2"
                                            label="2nd Address"
                                            placeholder="Enter address"
                                            value={get(property, "secondaryAddress", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlexHalf>
                                    <PropertyInfoFlexHalf></PropertyInfoFlexHalf>
                                </PropertyInfoWrapper>
                            </PropertyInformation>
                            <PropertyInformation>
                                <PropertyInfoWrapper>
                                    <PropertyInfoFlexHalf>
                                        <BSInput
                                            id="propertyType"
                                            label="Property Type"
                                            placeholder="Select type"
                                            value={get(property, "propertyType", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlexHalf>
                                    <PropertyInfoFlexHalf>
                                        <BSInput
                                            id="useType"
                                            label="Property Use"
                                            placeholder="Select use"
                                            value={getSpecialtyTypeDisplayName(
                                                get(property, "propertyType"),
                                                get(property, "propertyAttributes.specialtyType")
                                            )}
                                            disabled
                                        />
                                    </PropertyInfoFlexHalf>
                                </PropertyInfoWrapper>
                                <PropertyInfoWrapper>
                                    <PropertyInfoFlexThird>
                                        <BSInput
                                            id="marketArea"
                                            label="Market Area"
                                            value={get(property, "propertyAttributes.marketArea", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlexThird>
                                    <PropertyInfoFlexThird>
                                        <BSInput
                                            id="submarketArea"
                                            label="Submarket"
                                            value={get(property, "propertyAttributes.submarketArea", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlexThird>
                                    <PropertyInfoFlexThird>
                                        <BSInput
                                            id="micromarketArea"
                                            label="Micro Market"
                                            value={get(property, "propertyAttributes.micromarketArea", "")}
                                            disabled
                                        />
                                    </PropertyInfoFlexThird>
                                </PropertyInfoWrapper>
                                {get(property, "propertyAttributes.parcels", []).map((parcel, index) => (
                                    <React.Fragment>
                                        <PropertyInfoWrapper>
                                            <PropertyInfoFlexHalf>
                                                <BSInput
                                                    id="buildingName0"
                                                    label="Latitude"
                                                    value={get(parcel, "latitude", "")}
                                                    placeholder="Enter Latitude"
                                                    disabled
                                                />
                                            </PropertyInfoFlexHalf>
                                            <PropertyInfoFlexHalf>
                                                <BSInput
                                                    id="buildingName0"
                                                    label="Longitude"
                                                    value={get(parcel, "longitude", "")}
                                                    placeholder="Enter Longitude"
                                                    disabled
                                                />
                                            </PropertyInfoFlexHalf>
                                        </PropertyInfoWrapper>
                                        <PropertyInfoWrapper>
                                            <PropertyInfoFlex>
                                                <BSInput
                                                    id="buildingName0"
                                                    label="APN/Parcel Code/Parcel ID"
                                                    value={get(parcel, "apn", "")}
                                                    placeholder="Enter Parcel ID"
                                                    disabled
                                                />
                                            </PropertyInfoFlex>
                                        </PropertyInfoWrapper>
                                    </React.Fragment>
                                ))}
                            </PropertyInformation>
                        </div>

                        <Divider />

                        <FormTitle title="Building Information" />
                        <div>
                            <BuildingForm
                                {...props}
                                data={get(property, "propertyAttributes", {})}
                                context="property"
                                errors={{}}
                                disableInputs={true}
                                onChange={(field, value) => handleInput("property.propertyAttributes." + field, value)}
                            />
                        </div>

                        <Divider />

                        <FormTitle title="Parking Information" />
                        <div>
                            <ParkingInfoForm
                                {...props}
                                data={get(property, "propertyAttributes", {})}
                                context="property"
                                errors={{}}
                                disableInputs={true}
                                onChange={(field, value) => handleInput("property.propertyAttributes." + field, value)}
                            />
                        </div>
                        {toLower(propertyType) === "office" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Office Information" />
                                <div>
                                    <OfficeForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{}}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        {toLower(propertyType) === "healthcare" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Healthcare Information" />
                                <div>
                                    <HealthcareForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{}}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        {toLower(propertyType) === "industrial" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Industrial Information" />
                                <div>
                                    <IndustrialForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{ errors }}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        {toLower(propertyType) === "retail" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Retail Information" />
                                <div>
                                    <RetailForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{}}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        {toLower(propertyType) === "land" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Land Information" />
                                <div>
                                    <LandForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{}}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        {toLower(propertyType) === "multifamily" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Multifamily Information" />
                                <div>
                                    <MultifamilyForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{}}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        {toLower(propertyType) === "hospitality" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Hospitality Information" />
                                <div>
                                    <HospitalityForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{}}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        {toLower(propertyType) === "other" && (
                            <React.Fragment>
                                <Divider />
                                <FormTitle title="Other Information" />
                                <div>
                                    <OtherForm
                                        {...props}
                                        data={get(property, "propertyAttributes", {})}
                                        context="property"
                                        errors={{}}
                                        disableInputs={true}
                                        onChange={(field, value) =>
                                            handleInput("property.propertyAttributes." + field, value)
                                        }
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        <Divider />
                        <FormTitle title="Attached Documents" />
                        <DocumentDrop
                            entityKey={propertyKey}
                            type="property"
                            documentTypes="propertyDetail"
                            viewOnly={true}
                            parentType={"PROPERTY"}
                            stateCode={get(property, "primaryAddress.city.state.stateCode", null)}
                        />
                    </React.Fragment>
                )}

                {/*** Research ***/}

                {tab === "research_tab" && includes(["research", "dataEntry", "dataAdmin", "researchAdmin"], role) && (
                    <ResearchTab {...props} propertyKey={propertyKey} editResponse={handleEditResearchSnapshot} />
                )}
            </PaperPadding>

            <Dialog
                open={closeDealDialogOpen}
                onClose={handleClose}
                aria-labelledby="close-deal"
                aria-describedby="close-deal-dialog"
            >
                <DialogTitle id="close-deal">{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Closing this deal will start the invoice process for this transaction and move the listing to a
                        closed status. Portland Listings will be closed after the Comp for this Deal has been Submitted
                        and Approved.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={handleClose} color="secondary" autoFocus variant="contained">
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default PropertyDetail;
